/* eslint-disable max-len */
import 'react';

const DocReferenceFillSvg = (
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M0 0h14v14H0z" /><g fill="#5C6473" fillRule="nonzero" opacity=".6"><path d="M11.8 0c.663 0 1.2.619 1.2 1.382v11.06c0 .763-.537 1.382-1.2 1.382H2.2c-.663 0-1.2-.619-1.2-1.382V1.382C1 .62 1.537 0 2.2 0h9.6zm-.3 1.499h-9v10.824h9V1.499z" /><path d="M9.088 4.45a.75.75 0 01.102 1.493l-.102.007h-4.8a.75.75 0 01-.102-1.493l.102-.007h4.8zM7.088 7.85a.75.75 0 01.102 1.493l-.102.007h-2.8a.75.75 0 01-.102-1.493l.102-.007h2.8z" /></g></g></svg>
);
export default DocReferenceFillSvg;
